import React, { useState, useEffect } from "react";
import {
  saveConsentPreferences,
  hasConsentBeenSet,
  COOKIE_TYPES,
} from "../../../utils/cookieUtils";
import styles from "./CookieConsent.module.css";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!hasConsentBeenSet()) {
      setShowBanner(true);
    }
  }, []);

  const handleGotIt = () => {
    const allAccepted = {
      [COOKIE_TYPES.NECESSARY]: true,
      [COOKIE_TYPES.ANALYTICS]: true,
      [COOKIE_TYPES.MARKETING]: true,
      [COOKIE_TYPES.FUNCTIONAL]: true,
    };
    saveConsentPreferences(allAccepted);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className={styles.cookieBanner}>
      <button
        onClick={handleGotIt}
        className={styles.acceptButton}
      >
        Got it!
      </button>
      <p className={styles.bannerText}>
        We use cookies to ensure you get the best experience on our website.
        By using this site, you agree that we may store and access cookies on
        your device. Click{" "}
        <a
          href="https://www.engie.co.uk/privacy-notice-and-cookies/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Read privacy policy (opens in new page)"
        >
          here
        </a>{" "}
        to learn more about cookies.
      </p>
    </div>
  );
};

export default CookieConsent;
